export const CREATE_AMENITY2092 = "CREATE_AMENITY2092";
export const UPDATE_AMENITY2092 = "UPDATE_AMENITY2092";
export const DELETE_AMENITY2092 = "DELETE_AMENITY2092";
export const FETCH_AMENITY2092 = "FETCH_AMENITY2092";
export const LISTEN_TO_SELECTED_AMENITY2092 = "LISTEN_TO_SELECTED_AMENITY2092";
export const FILTER_AMENITY2092 = "FILTER_AMENITY2092";
